export default __webpack_public_path__ + "static/media/Prism.be8e720d.svg";